var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _class, _temp2;
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import * as React from 'react';
import Measure from 'react-measure';
var Tailor = (_temp2 = _class = function (_React$Component) {
  _inherits(Tailor, _React$Component);
  function Tailor() {
    var _temp, _this, _ret;
    _classCallCheck(this, Tailor);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.innerChild = React.createRef(), _this.state = {
      firstRun: true,
      doneSizing: false,
      finalSize: 0
    }, _this.causeResize = function () {
      _this.setState({
        doneSizing: false,
        finalSize: 0
      }, function () {
        _this.processText();
      });
    }, _this.processText = function () {
      if (!_this.state.doneSizing) {
        var content = _this.innerChild.current;
        var maxWidth = content.parentNode.offsetWidth;
        var initialHeight = content.parentNode.offsetHeight;
        var startSize = parseFloat(window.getComputedStyle(content, null).getPropertyValue('font-size'));

        // guess the final size and subtract 2 to reduce and/or eleminate false ellipses
        var _finalSize = startSize / content.scrollWidth * maxWidth - 2;

        // the above got us at the correct width, but the height might be off

        content.style.fontSize = _finalSize + 'px';
        var maxHeight = parseFloat(window.getComputedStyle(content.parentNode, null).getPropertyValue('height'));

        // only do height calc if we're in a fixed height element
        if (content.scrollHeight > maxHeight && maxHeight === initialHeight) {
          _finalSize = _finalSize / content.scrollHeight * maxHeight;
        }
        if (_finalSize > startSize && !_this.props.canGrow) {
          _finalSize = startSize;
        }
        if (_finalSize < _this.props.minSize) {
          _finalSize = _this.props.minSize;
        }
        _this.setState({
          finalSize: _finalSize,
          doneSizing: true
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  Tailor.prototype.componentDidMount = function componentDidMount() {
    // we process on first mount to avoid as much flashing as possible.
    this.processText();
  };
  Tailor.prototype.render = function render() {
    var _this2 = this;
    var _props = this.props,
      minSize = _props.minSize,
      canGrow = _props.canGrow,
      children = _props.children,
      style = _props.style,
      otherProps = _objectWithoutProperties(_props, ['minSize', 'canGrow', 'children', 'style']);
    var containerStyle = _extends({}, style, {
      // Fill whatever size our parent is
      display: 'block',
      width: '100%',
      height: '100%'
    });
    var contentStyle = {
      fontSize: this.state.finalSize > 0 ? this.state.finalSize + 'px' : 'inherit',
      display: this.state.doneSizing ? 'block' : 'inline-block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    };
    return React.createElement(Measure, {
      onResize: function onResize() {
        if (_this2.state.firstRun) {
          // We don't need to kick off a resize on the first run as
          // we'll already be doing one
          _this2.setState({
            firstRun: false
          });
        } else {
          // If this isn't the first run, we do want to resize the text as
          // this elements size has changed
          _this2.causeResize();
        }
      }
    }, function (_ref) {
      var measureRef = _ref.measureRef;
      return React.createElement('span', _extends({
        ref: measureRef,
        style: containerStyle
      }, otherProps), React.createElement('span', {
        ref: _this2.innerChild,
        style: contentStyle
      }, children));
    });
  };
  return Tailor;
}(React.Component), _class.defaultProps = {
  minSize: 11,
  canGrow: false
}, _temp2);
export { Tailor as default };